// extracted by mini-css-extract-plugin
export default {"whiteDiv":"Contact_whiteDiv__IN1ux","svg":"Contact_svg__g9RV8","BackColor":"Contact_BackColor__F0L4U"};